<template>
  <Modal
		class="personas long-modal"
		width="800"
		v-model="show"
    :loading="loading"
		@on-ok="ok"
		@on-cancel="cancel"
	>
		<h3 slot="header" class="modal-header">更新返回信息</h3>
    <Form
      style="margin-top:24px"
      ref="addData"
      :model="addData"
      :rules="ruleValidate"
      :label-width="120">
      <Row>
				<ul class="detail">
				<li>门店名称：{{addData.projectName}}</li>
				<li>房间号：{{addData.roomName}}</li>
				<li>姓名：{{addData.name}}</li>
			</ul>
      </Row>
			<Row>
				<Col span="10">
          <FormItem prop="returned" label="是否进入自如寓居住">
            <Select v-model="addData.returned" placeholder="请选择">
              <Option value=''>请选择</Option>
              <Option value='true'>是</Option>
              <Option value='false'>否</Option>
            </Select>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="bodyTemperature" label="返程日体温(℃)">
            <Input v-model="addData.bodyTemperature" placeholder="请输入"></Input>
          </FormItem>
        </Col>
			</Row>
			<Row>
				<Col span="10">
					<FormItem prop="returnDate" label="返程日期">
						<DatePicker style="width:100%" type="datetime" placeholder="请选择" format="yyyy-MM-dd" v-model="addData.returnDate"></DatePicker>
					</FormItem>
				</Col>
				<Col span="10">
          <FormItem prop="backTransportationType" label="返程交通方式">
            <Select v-model="addData.backTransportationType" multiple placeholder="请选择">
              <Option v-for="(item,index) in transportationArr" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="flightNumber" label="航班号">
            <Input v-model="addData.flightNumber" type="text" placeholder="请输入"></Input>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="trainTrips" label="火车车次">
            <Input v-model="addData.trainTrips" type="text" placeholder="请输入"></Input>
          </FormItem>
        </Col>
			</Row>
			<Row>
				<Col span="10">
          <FormItem prop="throughEpidemicArea" label="是否途径疫情重点地区">
            <Select v-model="addData.throughEpidemicArea" placeholder="请选择">
              <Option value=''>请选择</Option>
							<Option value='true'>是</Option>
              <Option value='false'>否</Option>
            </Select>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="throughEpidemicAreaCode" label="途径情况">
            <Select v-model="addData.throughEpidemicAreaCode" placeholder="请选择">
              <Option value=''>请选择</Option>
							<Option v-for="(item,index) in throughEpidemicAreaList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>

			</Row>
			<Row>
				<Col span="10">
          <FormItem prop="reachHighriskGroups" label="1.15后是否接触过高危人群">
            <Select v-model="addData.reachHighriskGroups" placeholder="请选择">
              <Option value=''>请选择</Option>
							<Option value='true'>是</Option>
              <Option value='false'>否</Option>
            </Select>
          </FormItem>
        </Col>
			</Row>
			<Row>
        <Col span="20">
          <FormItem label="备注">
            <Input v-model="addData.remark" type="textarea"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
	</Modal>
</template>

<script>
import {updateBackInfo} from 'api/customerhealth'
import {formatDateTime,deepClone} from "@/utils/format";


export default {
	props:{
		n:{
			type:Number,
			default:0
		},
		detailData:{
			type:Object,
      default(){
        return []
      }
		},
		transportationArr:{
      type:Array,
      default(){
        return []
      }
		},
		throughEpidemicAreaList:{
      type:Array,
      default(){
        return []
      }
    }
	},
	data(){
		const validates = (rule, value, callback) => {
			const pattern = /^[-+]?[0-9]*\.?[0-9]+$/
			if (!pattern.test(value)||value>45||value<34) {
				callback(new Error('请填写返程日体温(34<体温<45)'));
			} else {
				callback();
			}
		};
		return{
			show:false,
			loading:true,
			ruleValidate:{
				returned: [{required: true, message: '请选择是否进入自如寓居住', trigger: 'change', type: 'string'}],
				bodyTemperature: [{required: true, message: '请填写返程日体温(34<体温<45)', trigger: 'blur', type: 'number',validator: validates}],
			},
			addData:{}
		}
	},
	watch:{
		n(){
			// this.$refs['addData'].resetFields();
			// this.addData.remark = ''
			this.addData = deepClone(this.detailData)
			console.log(this.addData.backTransportationType)

			if(this.addData.backTransportationType){
				this.addData.backTransportationType = this.addData.backTransportationType.split(',')
			} else{
				this.addData.backTransportationType = []
			}
			console.log(this.addData.backTransportationType)
			this.show = true
		}
	},
	methods:{
		ok(){
			this.$refs['addData'].validate(bool => {
				if (bool) {
				const backTransportationTypeName = [];
				this.transportationArr.filter((item)=>{
					if(this.addData.backTransportationType.indexOf(item.value) > -1){
						backTransportationTypeName.push(item.text)
					}
				})
				this.throughEpidemicAreaList.filter(item=>{
					if(item.value == this.addData.throughEpidemicAreaCode){
						this.addData.throughEpidemicAreaDesc = item.text
					}
				})
				this.addData.backTransportationType = this.addData.backTransportationType.join(',')
				this.addData.backTransportationTypeName = backTransportationTypeName.join(',')
				this.addData.returnDate = this.format(this.addData.returnDate,false)
					const params = {
						...this.addData
					}
					updateBackInfo(params)
					.then(res=>{
						if(res.code === 0){
							this.$emit('done')
							this.$Message.success('保存成功')
						} else{
							this.$Message.error('保存失败')
						}
					})
					.catch(()=>{
						this.$Message.error('保存失败')
					})
					.finally(()=>{
            this.show = false
          })
				} else {
					this.changeLoading();
				}
			})
		},
		changeLoading(){
			this.loading = false;
			this.$nextTick(() => {
				this.loading = true
			})
		},
		format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
		cancel(){
			return
		}
	}
}
</script>

<style scoped>
	.detail li{
		width: 33%;
		float: left;
		margin-bottom: 30px;
		text-align: center;
	}
</style>
